import { Injectable } from '@angular/core';
import { QueryBuilderConfigs } from '@core/constants/query-builder-configs';
import { Kerkimi } from '@core/interfaces/models/kerkimi.interface';
import { QueryBuilderConfig } from 'ngx-angular-query-builder';
import { BehaviorSubject, map, take, combineLatest } from 'rxjs';
import { ApiService } from './api.service';
import { BurimiService } from './burimi.service';
import { FjalaPerzgjedhurLeksikografiService } from './fjala-perzgjedhur-leksikografi.service';
import { FjalaPerzgjedhurService } from './fjala-perzgjedhur.service';

@Injectable({
  providedIn: 'root',
})
export class QueryBuilderService {
  private baseUrl: string = 'queryBuilder';

  private _temporaryQueryBuilder$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private _config: QueryBuilderConfig = QueryBuilderConfigs.Config;

  constructor(
    private apiService: ApiService,
    private fjalaPerzgjedhurService: FjalaPerzgjedhurService,
    private fjalaPerzgjedhurLeksikografiService: FjalaPerzgjedhurLeksikografiService,
    private burimiService: BurimiService,
  ) {}

  get(queryBuilder: any) {
    return this.apiService.post<Kerkimi[]>(`${this.baseUrl}`, queryBuilder);
  }

  getSql(queryBuilder: any) {
    return this.apiService.post<any>(`${this.baseUrl}/sql`, queryBuilder);
  }

  getTemporaryQueryBuilder() {
    return this._temporaryQueryBuilder$.asObservable();
  }

  setTemporaryQueryBuilder(queryBuilder: any) {
    this._temporaryQueryBuilder$.next(queryBuilder);
  }

  getConfig() {
    return this._config;
  }

  load() {
    return combineLatest([
      this.fjalaPerzgjedhurService.getFromStore(),
      this.fjalaPerzgjedhurLeksikografiService.getFromStore(),
      this.burimiService.getFromStore()
    ]).pipe(
      take(1),
      map(
        ([
          fjalaPerzgjedhur,
          fjalaPerzgjedhurLeksikografi,
          burimi
        ]) => {
          this._config.fields['approval'].options = fjalaPerzgjedhur.map((item) => {
            return { name: item.pershkrimi, value: item.id };
          });
          this._config.fields['lex_approval'].options = fjalaPerzgjedhurLeksikografi.map((item) => {
            return { name: item.emri, value: item.id };
          });
          this._config.fields['source'].options = burimi.map((item) => {
            return { name: item.pershkrimi, value: item.id };
          });
        }
      )
    );
  }
}
